import React from '../../vendor/react';
import { useState } from '../../vendor/react';
import { KeyRound, LockKeyhole, Mail } from '../../vendor/lucide-react';
import { Link, navigate } from '../../vendor/react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { AuthNotice } from '../../components/auth/AuthNotice';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../features/auth/auth-store';
import { isEmail } from '../../features/auth/validation';

export function LoginPage() {
  const auth = useAuth();
  const [feedback, setFeedback] = useState('');

  const submit = async (event: SubmitEvent) => {
    event.preventDefault();
    setFeedback('');
    const data = new FormData(event.currentTarget as HTMLFormElement);
    const email = String(data.get('email') ?? '');
    const password = String(data.get('password') ?? '');
    if (!isEmail(email)) return setFeedback('Escribe un correo válido.');
    if (!password) return setFeedback('Escribe tu contraseña.');
    try {
      const result = await auth.actions.signIn(email, password);
      navigate(result.session?.user.platformRole === 'superadmin' || result.session?.user.platformRole === 'support' ? '/admin' : auth.workspace?.onboardingComplete ? '/app' : '/onboarding', { replace: true });
    } catch (error) {
      setFeedback(error instanceof Error ? error.message : 'No se pudo iniciar sesión.');
    }
  };

  return (
    <AuthLayout eyebrow="Acceso" title="Entra a NEXO COMERCIO" description="Usa el correo y la contraseña con los que creaste tu cuenta.">
      {auth.providerMode === 'local' && <div className="local-mode-card"><span>Modo local de revisión</span><strong>propietario@nexo.demo</strong><small>Contraseña: Nexo2026!</small><span className="local-admin-account">Panel maestro: admin@nexo.demo · NexoAdmin2026!</span></div>}
      {feedback && <AuthNotice tone="error">{feedback}</AuthNotice>}
      <form className="auth-form" onSubmit={submit}>
        <label className="auth-field"><span>Correo electrónico</span><div><Mail size={18} /><input name="email" type="email" autoComplete="email" placeholder="tu@negocio.com" required /></div></label>
        <label className="auth-field"><span>Contraseña</span><div><LockKeyhole size={18} /><input name="password" type="password" autoComplete="current-password" placeholder="Tu contraseña" required /></div></label>
        <div className="auth-form__meta"><label><input type="checkbox" name="remember" defaultChecked /> Mantener mi sesión</label><span>Recuperación por soporte</span></div>
        <Button type="submit" size="lg" className="full-width" icon={<KeyRound size={18} />}>Iniciar sesión</Button>
      </form>
      <p className="auth-card__footer">¿Todavía no tienes cuenta? <Link to="/registro">Crear cuenta</Link></p>
    </AuthLayout>
  );
}
